import { Avatar, makeStyles } from "@material-ui/core";

import bigSpenderIcon from "../assets/icons/bigspender.png";
import frequentIcon from "../assets/icons/frequent.png";

const useStyle = makeStyles(() => ({
  badgeIcon: {
    width: 35,
    height: 30,
  },
}));

const Badge = ({ data }) => {
  let icon;
  const classes = useStyle();
  if (data?.name === "Big Spender") {
    icon = bigSpenderIcon;
  }
  if (data?.name === "Frequent Member") {
    icon = frequentIcon;
  }
  return <Avatar alt={"BS"} className={classes.badgeIcon} src={icon} />;
};

export default Badge;
